/**
 * DocumentPreview
 * Prévia do documento emitido.
 *
 * O HTML vai num `<iframe sandbox>` e ISSO NÃO É DETALHE: renderizado direto na
 * página, o CSS do documento e o do MUI se contaminam mutuamente e a prévia
 * deixa de representar o resultado impresso.
 *
 * @version 2026.1.0
 */

import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface DocumentPreviewProps {
  /** HTML completo devolvido por `POST /documents/preview`. */
  html: string;
  height?: number;
}

export const DocumentPreview: React.FC<DocumentPreviewProps> = ({ html, height = 640 }) => (
  <Box>
    <Typography variant="subtitle1" gutterBottom>
      Prévia do documento
    </Typography>

    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Box
        component="iframe"
        title="Prévia do documento"
        // `sandbox` vazio: sem scripts, sem formulários, sem navegação a partir do
        // conteúdo — a prévia só precisa exibir HTML e CSS.
        sandbox=""
        srcDoc={html}
        sx={{
          display: 'block',
          width: '100%',
          height,
          border: 'none',
          backgroundColor: '#fff',
        }}
      />
    </Paper>
  </Box>
);

export default DocumentPreview;
